module.exports = __webpack_public_path__ + "static/Hero-gov.a016ac44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Hero-gov.jpg
// module id = 493
// module chunks = 53566712009029